import {selectApp} from "./selectApp";

export const selectCanShowKaskoFrameOffers = (state) => {
  return selectApp(state).canShowKaskoFrameOffers;
}
